import React from 'react'
import { withRouter } from 'react-router-dom'
import {connect} from 'react-redux';
import {Flex} from '/app/src/component'
import style from './style.css';
import SystemModel from '/app/src/model/System/model';
import TransferModal from './Transfer'
import SVG from 'react-inlinesvg';

class Overlay extends React.Component {
    constructor(props){
        super(props);
        this._outsideClick = this._outsideClick.bind(this);
        this._insideClick = this._insideClick.bind(this);
    }
    _outsideClick(e){
        this.props.dispatch(SystemModel.closeModal())
    }
    _insideClick(e){
        e.stopPropagation();
    }

    //Renders the modal for transfering conversations to co-workers
    _renderTransferRoute(){
        return (
            <Flex column grow className={style.Modal}>
                <Flex fontSize='20px' className={style.ModalHeader} width='100%' hAlignContent='center' vAlignContent='center'>
                    <SVG  style={{height: '40px', width: '40px', fill: '#4ec1e0'}} cacheGetRequests={true} src='/images/ErrandTransfer_M.svg' />
                    <Flex marginLeft='20px'>
                    Överför ärende
                    </Flex>
                </Flex>
                <Flex className={style.ModalBody} column>
                    <TransferModal data={this.props.data}/>
                </Flex>
            </Flex>
        )
    }
    render(){
        //let route = this.props.match.params.route;
        let modal = this.props.modal;
        //modal = 'transfer';

        let innerContent;
        switch(modal){
            case 'transfer':
                innerContent = this._renderTransferRoute();
                break;
            default:
                return null;
        }
        return (
            <Flex className={style.ModalWrapper} hAlignContent='center' onClick={this._outsideClick}>
                <Flex className={style.Modal} onClick={this._insideClick}>
                    {innerContent}
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, ownProps){
    //TODO fixed to route + toogle system instead
    let modalAction = state.getIn(['system', 'modal', 'route'])
    let modalData = state.getIn(['system', 'modal', 'data'])
    return {
        'modal': modalAction,
        'data': modalData
    }

}

export default withRouter(connect(mapStateToProps)(Overlay));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Modal/index.js